import { render, staticRenderFns } from "./ProrateActionPicker.vue?vue&type=template&id=881dcf58"
import script from "./ProrateActionPicker.vue?vue&type=script&lang=js"
export * from "./ProrateActionPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports